import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Circle, Defs, RadialGradient, Stop } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function GlowPoint(props) {
  const { radius, color } = props;

  const size = radius * 2;

  return (
    <Svg width={size} height={size}>
      <Defs>
        <RadialGradient
          id="grad"
          cx={0}
          cy={0}
          rx={radius}
          fx={0}
          fy={0}
          ry={radius}
        >
          <Stop offset="0" stopColor={color} stopOpacity="0.5" />
          <Stop offset="1" stopColor={color} stopOpacity="0.8" />
        </RadialGradient>
      </Defs>
      <Circle cx={radius} cy={radius} r={radius} fill="url(#grad)" />
      <Circle cx={radius} cy={radius} r={radius * 0.8} fill={color} />
    </Svg>
  );
}

GlowPoint.propTypes = {
  radius: PropTypes.number.isRequired,
  color: PropTypes.string,
};

GlowPoint.defaultProps = {
  color: 'rgb(122,184,0)',
};

export default pure(GlowPoint);
